export const ALPHABET_PATTERN = /^[A-Za-z]+$/;

export const ALPHABET_SPACE_PATTERN = /^[A-Za-z ]+$/;

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const MOBILE_NO_PATTERN = /^\d{10}$/;

export const DECIMAL_PATTERN = /^\d*\.?\d{0,3}$/;

export const INDIAN_MOBILE_NO_PATTERN = /^(0?)[6789]{1}\d{9}$/;

export const NUMBER_ONLY_PATTERN = /^[0-9]+$/;

export const NOT_ALLOW_SPACE = /^\S*$/;

export const PIN_CODE_PATTERN = /^(\d{4}|\d{6})$/;

export const GST_PATTERN =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const INSTAGRAM_REGEX = /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?(\?.*)?$/;

export const ALPHABET_NUMBER_SPACE_PATTERN = /^[a-zA-Z 0-9]+$/;